<template>
  <div class="field-preview">
    <div class="field-label">
      <span>{{ field.label }}</span>
      <v-chip x-small color="primary" class="ml-2" v-if="field.required">Required</v-chip>
    </div>

    <div class="field-description" v-if="field.description">
      <v-icon small color="grey">mdi-information-outline</v-icon>
      <span>{{ field.description }}</span>
    </div>

    <div class="rating-container mt-2">
      <v-rating
        v-model="rating"
        :length="ratingLength"
        hover
        background-color="grey lighten-3"
        color="amber"
        dense
      ></v-rating>

      <div class="rating-scale mt-2" v-if="hasMinMax">
        <div class="rating-min">{{ field.minRating || 1 }}</div>
        <div class="rating-max">{{ field.maxRating || 5 }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RatingFieldPreview',
  props: {
    field: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      rating: 0
    }
  },
  computed: {
    hasMinMax() {
      return this.field.minRating !== undefined || this.field.maxRating !== undefined;
    }
  },
  created() {
    // Initialize with minimum value if set
    if (this.field.minRating !== undefined) {
      this.rating = this.field.minRating;
    }
  }
}
</script>

<style scoped>
.field-preview {
  display: flex;
  flex-direction: column;
}

.field-label {
  font-weight: 500;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
}

.field-description {
  margin-bottom: 8px;
  font-size: 0.85rem;
  color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  gap: 4px;
}

.rating-container {
  background-color: #f9f9f9;
  border-radius: 4px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.rating-scale {
  width: 100%;
  display: flex;
  justify-content: space-between;
  font-size: 0.75rem;
  color: rgba(0, 0, 0, 0.6);
  margin-top: 8px;
  padding: 0 12px;
}
</style>
